module.exports = __webpack_public_path__ + "static/media/herders_c.d06dac61.tif";